export enum UserTypeEnum {
    ADMIN = 'ADMIN',
    VENDOR = 'VENDOR',
    SUPERVISOR = 'SUPERVISOR',
    CONCILIATOR = 'CONCILIATOR'
}
